import { getTemplateData } from '/providers/templates-api'
import _ from "lodash"

export default async ({ apiSource, apiKey, templateId }) => {
  try {
    const data = await getTemplateData({ apiSource, apiKey, templateId })
    // TODO handle error
    const template = data.template
    let instanceData = template.instance_data

    // Our internal type. Enables us to differentiate between different uses for the same pass type. 
    const smartixPassType = template.pass_type_id

    const applePassType = template.apple_pass_type
    const appleModel = template.apple_model
    const appleTemplate = template.apple_template
    const appleSubType = template.apple_sub_type

    const googlePassType = template.google_pass_type
    const googleClass = template.google_class
    const googleObject = template.google_object
    const googleSubType = template.google_sub_type

    const templateName = template.name
    const templateDescription = template.description
    const isSmartixScannerPass = template.smartix_scanner === 1
    const scannerData = template.scanner_data
    const scannerInstanceData = template.scanner_instance_data

    const metaData = {
      name: template.name,
      wizardPermitted: template.wizardPermitted,
      expire_on_zero_balance: template.expire_on_zero_balance === 1,
      retention_period : template.retention_period,
      max_notifications : template.max_notifications
    }

    if (isSmartixScannerPass) {
      instanceData.__scanner_barcode__ = "Smartix scanner barcodes are created automatically when a pass is created. They are not replicated in the editor. We use this text to create a barcode that looks right."
    }

    return { isSmartixScannerPass, smartixPassType, appleTemplate, googleObject, appleModel, googleClass, applePassType, googlePassType, appleSubType, googleSubType, templateName, templateDescription, metaData, instanceData, scannerInstanceData, scannerData }
  }
  catch (err) {
    throw err
  }
} 
